"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControlLabelWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _formik = require("formik");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormControlLabelWrapper = function FormControlLabelWrapper(_ref) {
  var classes = _ref.classes,
      radioValue = _ref.radioValue,
      label = _ref.label,
      isChecked = _ref.isChecked,
      fieldName = _ref.fieldName,
      closePopup = _ref.closePopup;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var handleRadioChange = function handleRadioChange() {
    setFieldValue(fieldName, radioValue);
    setTimeout(function () {
      return setFieldTouched('category', true);
    });
    closePopup();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.formControlLabelWrapper,
    onClick: handleRadioChange
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, {
      checked: isChecked
    }),
    label: /*#__PURE__*/_react.default.createElement(_core.Typography, null, label)
  }));
};

exports.FormControlLabelWrapper = FormControlLabelWrapper;